// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/componentCache.js#1 $
'use strict';

/**
* @ngdoc service
* @name tcApp.ComponentCache
* @description
* Component Cache maintains state of the component between page navigation events.
*
*/
angular.module('tcApp')
.factory('ComponentCache', function($cacheFactory, $rootScope, $route, $location, SystemRouter) {
	// tracks current banner data to ensure that cached component data always includes banner data
	var currentBannerData = {};

	var componentCache = $cacheFactory('componentCache');
	componentCache.getComponentData = function(params) {
		var data = componentCache.get(angular.toJson(params));
		if (data) {
			data._isCached = true;
			return {data: data};
		}
		return null;
	};

	// Remove any data that should not be cached, e.g. Password/PIN fields
	var removeUncachedItems = function(cacheData) {
		if (angular.isUndefined(cacheData)) return cacheData;

		if (angular.isDefined(cacheData.items)) {
			angular.forEach(cacheData.items, function(item) {
				if (item.isPIN) item.value = '';

				if (angular.isDefined(item.displayType)) {
					// Recursively remove data for nested components
					if ((item.displayType === 'CX') && (angular.isDefined(item.componentData))) {
						removeUncachedItems(item.componentData);
					}

					// Handle custom items with component data (OrderEntry route)
					if ((item.displayType === 'S')
						&& (angular.isObject(item.value))) {
						angular.forEach(item.value, function(customItem) {
							if (angular.isDefined(customItem.data)) {
								removeUncachedItems(customItem.data);
							}
						});
					}
				}
			});
		}
		// OrderEntry route data is on this property
		if (angular.isDefined(cacheData.cmpOEPortal)) {
			cacheData.cmpOEPortal.data = removeUncachedItems(cacheData.cmpOEPortal.data);
		}
		delete cacheData._isCached;

		return cacheData;
	};

	/* eslint-disable angular/on-watch */
	// Executes after 'tcMenu:MainMenuSelected' event
	$rootScope.$on('$routeChangeStart', function($event, newRoute, oldRoute) {
		// clear cache if reloading current route
		if (oldRoute
			&& (($location.path() === '/Reload') || (angular.equals(oldRoute.params, newRoute.params)))) {
			componentCache.remove(angular.toJson(oldRoute.params));
			return;
		}
		if (oldRoute && oldRoute.scope && oldRoute.scope.resolveCtrl) {
			if ((angular.isDefined(newRoute.params.Dialog))
				&& (angular.isDefined(oldRoute.params.Dialog))) {
				// Never cache when navigating to a lower level
				if (newRoute.params.Dialog < oldRoute.params.Dialog) return;

				// For Edit components where a new record was created or other custom routes,
				// do not cache when navigating through a workflow
				if ((newRoute.params.Dialog == oldRoute.params.Dialog)
				&& ((angular.isDefined(oldRoute.scope.resolveCtrl.data) && (oldRoute.scope.resolveCtrl.data.doNotCache))
					|| (oldRoute.cacheCleared))) {
					// Remove previous cache if one was added prviously
					componentCache.remove(angular.toJson(oldRoute.params));
					return;
				}
			}
			// do not cache if component needs to always reload
			if (angular.isDefined(oldRoute.scope.resolveCtrl.data) && (oldRoute.scope.resolveCtrl.data.componentAlwaysReload)) {
				return;
			}
			if (!oldRoute.cacheCleared) {
				var cacheData = removeUncachedItems(oldRoute.scope.resolveCtrl.data);
				if (angular.isObject(cacheData) && angular.isUndefined(cacheData.bannerData)) {
					// ensure the banner stays up to date on breadcrumb
					cacheData.bannerData = currentBannerData;
				}
				componentCache.put(angular.toJson(oldRoute.params), cacheData);
			}
		}
	});

	$rootScope.$on('tcMenu:MainMenuSelected', function() {
		// Set flag to indicate the Cache was cleared, so Cache item is not added when changing route
		$route.current.cacheCleared = true;
		componentCache.removeAll();
		SystemRouter.unlockAll();
	});

	$rootScope.$on('Global:updateBanner', function(_, bannerData) {
		currentBannerData = bannerData;
	});

	return componentCache;
});
